<template>
  <div>
    <div class="qklw_list flex flex_wrap" v-if="list.length > 0">
      <div
        class="qklw_item flex my_card pointer"
        v-for="(item, index) in list"
        :key="index"
        @click="$goDetail(item)"
      >
        <img
          v-lazy="
            item.cover
              ? `/apis/${item.cover}`
              : require('../../../assets/imgs/placeholder/no_img.png')
          "
          alt=""
          :title="item.title_zh"
        />
      </div>
    </div>
    <img
      v-else
      style="height: 288px; margin: 0 auto"
      src="../../../assets/imgs/placeholder/no_data.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonQklw",
  props: ["list"],
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="less" scoped>
.qklw_list {
  .qklw_item {
    width: calc((100% - 5 * 16px) / 6);
    margin-right: 16px;
    border-radius: 6px;
    overflow: hidden;
    &:nth-of-type(6n) {
      margin-right: 0;
    }
    > img {
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }
}
</style>